import {
  /* PRICE LIST */
  GET_PRICES_DATA_SUCCESS,
  GET_PRICES_DATA_FAIL,
  ADD_PRICE_PRODUCT_SUCCESS,
  ADD_PRICE_PRODUCT_FAIL,
  UPDATE_PRICE_PRODUCT_SUCCESS,
  UPDATE_PRICE_PRODUCT_FAIL,
  DELETE_PRICE_PRODUCT_SUCCESS,
  DELETE_PRICE_PRODUCT_FAIL,
  UPDATE_RESP_REGION_SUCCESS,
  UPDATE_RESP_REGION_FAIL,
  CLEAR_FONT_SUCCESS,
  GET_FONT_SUCCESS,
  GET_FONT_FAIL,

  /* PRICE INFO */
  GET_INFO_DATA_SUCCESS,
  GET_INFO_DATA_FAIL,
  ADD_INFO_DATA_SUCCESS,
  ADD_INFO_DATA_FAIL,
  UPDATE_INFO_DATA_SUCCESS,
  UPDATE_INFO_DATA_FAIL,
  DELETE_INFO_DATA_SUCCESS,
  DELETE_INFO_DATA_FAIL,


  // GET_CAT_PRODUCTS_DATA_SUCCESS,
  // GET_CAT_PRODUCTS_DATA_FAIL,
  // GET_ACCESS_DATA_SUCCESS,
  // GET_ACCESS_DATA_FAIL,
  // GET_PRODUCTS_DATA_SUCCESS,
  // GET_PRODUCTS_DATA_FAIL,
  // GET_REG_PRODUCTS_DATA_SUCCESS,
  // GET_REG_PRODUCTS_DATA_FAIL,


  // GET_REGION_INFO_SUCCESS,
  // GET_REGION_INFO_FAIL,

  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

const INIT_STATE = {
  languages: [],
  countries: [],
  categories: [],
  sub_categories: [],
  products: [],
  price_countries: [],
  selected_product: [],
  imported_products: [],
  fonts: [],
  users: [],
  loading: false
};

const priceList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRICES_DATA_SUCCESS:
      console.log(action.payload)
      return {
        ...state,
        languages: action.payload[0],
        countries: action.payload[1],
        categories: action.payload[2],
        sub_categories: action.payload[3],
        products: action.payload[4],
        users: action.payload[5],
      };
    case GET_PRICES_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_PRICE_PRODUCT_SUCCESS:
      return {
        ...state,
        products: action.payload,
        success: { data: "success" },
      };
    case ADD_PRICE_PRODUCT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_PRICE_PRODUCT_SUCCESS: {
      const updatedItems = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];

      return {
        ...state,
        products: state.products.map(service => {
          const updated = updatedItems.find(
            item => item._id.toString() === service._id.toString()
          );
          return updated ? { ...service, ...updated } : service;
        }),
        success: { data: "success" },
      };
    }
    case UPDATE_PRICE_PRODUCT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_PRICE_PRODUCT_SUCCESS:
      return {
        ...state,
        products: action.payload,
        // products: state.products.filter(
        //   service => service._id.toString() !== action.payload._id.toString()
        // ),
      };
    case DELETE_PRICE_PRODUCT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_RESP_REGION_SUCCESS:
      return {
        ...state,
        countries: action.payload,
        success: { data: "success" },
      };
    case UPDATE_RESP_REGION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CLEAR_FONT_SUCCESS:
      return {
        ...state,
        fonts: [],
      };
    case GET_FONT_SUCCESS:
      return {
        ...state,
        fonts: action.payload
      };
    case GET_FONT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_INFO_DATA_SUCCESS:
      return {
        ...state,
        languages: action.payload.languages,
        countries: action.payload.countries,
        categories: action.payload.categories,
        sub_categories: action.payload.sub_categories,
        users: action.payload.users,
      };
    case GET_INFO_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_INFO_DATA_SUCCESS:
      return {
        ...state,
        [action.payload[0]]: action.payload[0] === 'categories' ? action.payload[1] : [...state[action.payload[0]], action.payload[1]],
        success: { data: "success" },
      };
    case ADD_INFO_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_INFO_DATA_SUCCESS:
      return {
        ...state,
        [action.payload[0]]: action.payload[0] === 'categories'
        ? action.payload[1]
        : state[action.payload[0]].map(service =>
            service._id.toString() === action.payload[1]._id.toString()
              ? { ...service, ...action.payload[1] }
              : service
          ),
        success: { data: "success" },
      };
    case UPDATE_INFO_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_INFO_DATA_SUCCESS:
      return {
        ...state,
        [action.payload[0]]: action.payload[0] === 'categories' ? action.payload[1] : state[action.payload[0]].filter( service => service._id.toString() !== action.payload[1]._id.toString() ),
      };
    case DELETE_INFO_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
          



    // case GET_CAT_PRODUCTS_DATA_SUCCESS:
    //   return {
    //     ...state,
    //     products: action.payload,
    //   };
    // case GET_CAT_PRODUCTS_DATA_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };
    // case GET_ACCESS_DATA_SUCCESS:
    //   return {
    //     ...state,
    //     price_countries: action.payload[0],
    //     users: action.payload[1],
    //   };
    // case GET_ACCESS_DATA_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };
    // case GET_PRODUCTS_DATA_SUCCESS:
    //   return {
    //     ...state,
    //     imported_products: action.payload[0],
    //     fonts: action.payload[1],
    //   };
    // case GET_PRODUCTS_DATA_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };
    // case GET_REG_PRODUCTS_DATA_SUCCESS:
    //   return {
    //     ...state,
    //     imported_products: action.payload[0],
    //     fonts: action.payload[1],
    //   };
    // case GET_REG_PRODUCTS_DATA_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };




    // case GET_REGION_INFO_SUCCESS:
    //   return {
    //     ...state,
    //     selected_product: action.payload
    //   };
    // case GET_REGION_INFO_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };


    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
};

export default priceList;
